var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOverview = function SvgOverview(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,22.109A23.412,23.412,0,0,1,24.415,24,11.207,11.207,0,0,0,27,16.706,11.832,11.832,0,0,0,15,5,11.832,11.832,0,0,0,3,16.706,11.729,11.729,0,0,0,5.585,24,23.412,23.412,0,0,1,15,22.109Z",
    className: "a"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 2,
    className: "a",
    transform: "translate(15 7.918)"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.4,
    y2: 1.4,
    className: "a",
    transform: "translate(8.42 10.271)"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2,
    className: "a",
    transform: "translate(6 16.706)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    className: "a",
    transform: "translate(22 16.706)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.4,
    y2: 1.4,
    className: "a",
    transform: "translate(20.18 10.271)"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 4,
    y1: 8,
    className: "a",
    transform: "translate(14.818 13.9)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOverview);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI1IDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO3N0cm9rZTojZmZmO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMH08L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi41IC00LjUpIj48cGF0aCBkPSJNMTUsMjIuMTA5QTIzLjQxMiwyMy40MTIsMCwwLDEsMjQuNDE1LDI0LDExLjIwNywxMS4yMDcsMCwwLDAsMjcsMTYuNzA2LDExLjgzMiwxMS44MzIsMCwwLDAsMTUsNSwxMS44MzIsMTEuODMyLDAsMCwwLDMsMTYuNzA2LDExLjcyOSwxMS43MjksMCwwLDAsNS41ODUsMjQsMjMuNDEyLDIzLjQxMiwwLDAsMSwxNSwyMi4xMDlaIiBjbGFzcz0iYSIvPjxsaW5lIHkyPSIyIiBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUgNy45MTgpIi8+PGxpbmUgeDI9IjEuNCIgeTI9IjEuNCIgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguNDIgMTAuMjcxKSIvPjxsaW5lIHgyPSIyIiBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiAxNi43MDYpIi8+PGxpbmUgeDE9IjIiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMiAxNi43MDYpIi8+PGxpbmUgeDE9IjEuNCIgeTI9IjEuNCIgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjE4IDEwLjI3MSkiLz48bGluZSB4Mj0iNCIgeTE9IjgiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC44MTggMTMuOSkiLz48L2c+PC9zdmc+";